// HomePage.tsx
import { INotificationMessage } from "@fl/shared/src/types/messages";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ParamsFuncs from "../../utils/paramsFuncs";
import DefaultBasePage from "../default/base"; // ajuste o caminho conforme necessário

const HomePage: React.FC = () => {
  const location = useLocation();
  const search = useLocation().search;
  const [messages, setMessages] = useState<INotificationMessage[]>([]);

  useEffect(() => {
    const currentMessages: INotificationMessage[] = [];

    if (
      location.state &&
      location.state.message &&
      location.state.message.length > 0
    )
      currentMessages.push(...location.state.message);

    const message = new ParamsFuncs(search).getMessages();
    if (message.length > 0) currentMessages.push(...message);

    setMessages(currentMessages);
  }, []);

  return (
    <DefaultBasePage
      title="Bem-vindo ao Sistemas Suporte FL"
      message={messages}
    >
      <div className="text-justify">
        <p>
          Oferecendo recursos adicionais à <strong>Superlógica</strong>, para
          melhorar a gestão financeira, cobrança, fiscal e muito mais.
        </p>
      </div>
    </DefaultBasePage>
  );
};

export default HomePage;
